import React from 'react';
import css from './FlipAndWinCards.css';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { cardAlreadyFlipped } from './helpers';
import CardContentNonFlipped from './CardFrontSide';
import CardBackSide from './CardBackSide';

export const FlipAndWinCards = ({ cards, ...rest }) => {
    const currentUser = useSelector(state => state.user.currentUser);

    const { flipAndWinData } = currentUser?.attributes?.profile?.privateData || {};
    const { cardsFlipped } = flipAndWinData || { cardsFlipped: {} };

    return (
        <div className={css.flipAndWinCardsHolder}>
            {cards.map((card, index) => (
                <div key={card.id || index} className={css.flipAndWinCardsWrapper}>
                    <div
                        className={classNames(css.flipAndWinCardsItem, {
                            [css.flipped]: cardAlreadyFlipped(card, cardsFlipped) || '',
                        })}
                    >
                        <CardContentNonFlipped currentUser={currentUser} card={card} {...rest} />
                        <CardBackSide card={card} currentUser={currentUser} />
                    </div>
                </div>
            ))}
        </div>
    );
};
